'use client'

import { useGalleriesQuery } from '@/generated/graphql'
import Link from 'next/link'
import { LoadingSpinner } from '@/General/LoadingSpinner'

export const GalleryGrid = () => {
  const { data, isPending, error } = useGalleriesQuery()

  if (isPending) {
    return (
      <div className="flex justify-center py-12">
        <LoadingSpinner />
      </div>
    )
  }

  if (error || !data?.galleries) {
    return (
      <div className="text-center py-12">
        <p className="text-gray-600">Unable to load galleries at this time.</p>
      </div>
    )
  }

  const galleries = data.galleries.filter(
    gallery => gallery.leadPhotoUrl != null
  )

  if (galleries.length === 0) {
    return (
      <div className="text-center py-12">
        <p className="text-gray-600">No galleries available.</p>
      </div>
    )
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
      {galleries.map(gallery => {
        const imageUrl = gallery.leadPhotoUrl
          ? `${gallery.leadPhotoUrl}?width=600`
          : null

        return (
          <Link
            key={gallery.id}
            href={`/magic-conventions/gallery/${gallery.urlstub}/`}
            className="group"
          >
            <div className="relative overflow-hidden rounded-lg shadow-lg transition-all duration-300 hover:shadow-2xl hover:scale-[1.02] bg-gray-900 aspect-[16/9]">
              {imageUrl ? (
                <img
                  src={imageUrl}
                  alt={gallery.title || 'Gallery photo'}
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  loading="lazy"
                />
              ) : (
                <div className="w-full h-full bg-gradient-to-br from-gray-800 to-gray-900 flex items-center justify-center">
                  <span className="text-gray-500 text-sm">No image</span>
                </div>
              )}
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-4 transform translate-y-2 group-hover:translate-y-0 transition-transform duration-300">
                <h3 className="text-white text-xl font-semibold mb-1">
                  {gallery.title}
                </h3>
                {gallery.year && (
                  <p className="text-gray-300 text-sm">{gallery.year}</p>
                )}
              </div>
            </div>
          </Link>
        )
      })}
    </div>
  )
}
